import { Clock, CheckCircle, AlertCircle, Loader } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const VerificationStatus = ({ status }) => {
  const statusConfig = {
    pending: {
      icon: Clock,
      text: 'Verificación Pendiente',
      description: 'Tu pago está siendo verificado por nuestro equipo',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      iconBg: 'bg-yellow-100'
    },
    processing: {
      icon: Loader,
      text: 'Procesando Pago',
      description: 'Estamos procesando tu información de pago',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      iconBg: 'bg-blue-100'
    },
    approved: {
      icon: CheckCircle,
      text: 'Pago Aprobado',
      description: 'Tu cuenta ha sido activada exitosamente',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      iconBg: 'bg-green-100'
    },
    rejected: {
      icon: AlertCircle,
      text: 'Pago Rechazado',
      description: 'Hubo un problema con tu pago. Por favor, intenta nuevamente',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      iconBg: 'bg-red-100'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.pending;
  const Icon = config?.icon;

  return (
    <div className={`${config?.bgColor} ${config?.borderColor} border-2 rounded-lg p-6`}>
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-full ${config?.iconBg}`}>
          <Icon className={`w-8 h-8 ${config?.color} ${status === 'processing' ? 'animate-spin' : ''}`} />
        </div>
        <div className="flex-1">
          <h3 className={`text-xl font-bold ${config?.color}`}>{config?.text}</h3>
          <p className="text-sm text-muted-foreground mt-1">
            {config?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationStatus;